import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import ItemsMovementTotal from "./ItemsMovementTotal";
const defaultAutos = {
  Safes: [],
};

export default function ItemsMovementTotalCon() {
  
  
  const tb = {
    wait: true,
    Safes: true,
    Currencies: true,
    Branches: true,
    groups: true,
    costcenters: true,
    stor: sto,
    parms: { safe: -1},
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb
  );

  if (fetchAll || !AutoOptions?.Safes) return <LoadingPage />;

  return (
    <ItemsMovementTotal
      {...{
        AutoOptions: AutoOptions?.Safes ? AutoOptions : defaultAutos,
      }}
    />
  );
}
